module.exports = __webpack_public_path__ + "img/zhhb-1.2630d0e3.png";